export class MessageTemplateModalModel {
}
